var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"success-seminar"},[_c('div',{staticClass:"success-seminar__wrap"},[_c('h2',[_vm._v(" Наші навчальні заходи - це концентрат інформації та неймовірна атмосфера. Найближчим часом з Вами зв'яжеться менеджер та підтвердить Ваш запис. ")])])])
}]

export { render, staticRenderFns }